module.exports = __webpack_public_path__ + "images/ExternalPromo/weebly-378893-300_250.gif?c3e3b";